import { mapActions, mapGetters, mapMutations } from "vuex";
import { checkAccess } from "@/helpers/access";

export const entering = {
  created() {
    this.getParams({
      account: "1",
      gfirme: "1",
      gkindpay: "1",
      gusers: "1",
      codepay: "1",
      codereason: "1",
      guserspackedit: "1",
      street: "1",
      gregion: "1",
      statuspay: "1",
      gservice: "1",
      gzone: "1",
      gcurrency: "1"
    });
  },
  beforeRouteEnter(to, from, next) {
    checkAccess(40) ? next() : next("/");
  },
  beforeRouteLeave(to, from, next) {
    if (this.packList.length > 0) {
      this.$confirm(this.$t("common.route.leave"), "", {
        confirmButtonText: this.$t("common.buttons.confirmYes"),
        cancelButtonText: this.$t("common.buttons.confirmNo"),
        cancelButtonClass: "cancel-button",
        type: "warning"
      })
        .then(() => {
          next();
        })
        .catch(() => {});
    } else {
      next();
    }
  },
  beforeDestroy() {
    this.clearPackList();
    this.clearInfoPay();
    this.clearPackVerification();
    this.clearReturnPack();
    this.clearHoldPack();
    this.clearPostingPrepare();
    this.clearPostingComplete();
    this.clearPostingAllPrepare();
    this.clearPackSelected();
    this.clearCountbands();
    this.clearOneCountband();
    this.clearCountbandsEdit();
    this.clearCountbandsDelete();
  },
  computed: {
    ...mapGetters(["packList", "initPage"])
  },
  methods: {
    ...mapMutations([
      "clearPackList",
      "clearInfoPay",
      "clearPackVerification",
      "clearReturnPack",
      "clearHoldPack",
      "clearPostingPrepare",
      "clearPostingComplete",
      "clearPostingAllPrepare",
      "clearPackSelected",
      "clearCountbands",
      "clearOneCountband",
      "clearCountbandsEdit",
      "clearCountbandsDelete"
    ]),
    ...mapActions(["getParams"])
  }
};
